import { render } from "./index.vue?vue&type=template&id=f9c9bd52&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f9c9bd52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9c9bd52"

export default script